import {
	faChevronLeft,
	faEdit,
	faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Button,
	CardLink,
	Col,
	FormGroup,
	Input,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
	Spinner,
} from "reactstrap";
import { Dispatch } from "redux";
import { dabFilmsAction } from "../../actions/dabFilmsAction";
import { videoHotlineAction } from "../../actions/videoHotlineAction";
import { LoadingSpinnerModal } from "../../components/dab";
import { showAlert } from "../common/functions";
import { getLoggedUserId } from "../../services/selectors/Accounts";
import { store } from "react-notifications-component";
import ReactPaginate from "react-paginate";

interface DABFilmsProps {
	dispatch: Dispatch<any>;
	dabFilmsData: any;
	videoHotlineData: any;
	title?: string;
}

const DABFilmsList: React.SFC<DABFilmsProps> = ({
	dispatch,
	dabFilmsData,
	videoHotlineData,
	title
}) => {
	const history = useHistory();

	const [isFilter, setFilter] = useState(false);
	const [fadeIn, setFadeIn] = useState(false);
	const [selectedId, setSelectedId] = useState(-1);
	const [dabFilmsList, setDabFilmsList] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [showClearFilter, setShowClearFilter] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [searchText, setSearch] = useState<string>("");
	const [debouncedSearch, setDebouncedSearch] = useState<string>("");

	React.useEffect(() => {
		const handler = setTimeout(() => {	
			setCurrentPage(1);
			setDebouncedSearch(searchText);
		}, 400);
		return () => {
			clearTimeout(handler);
		};
	}, [searchText]);

	React.useEffect(() => {
		if (videoHotlineData?.message?.messageBoardId) {
			const body = {
				pageNumber: currentPage,
				pageSize: 25,
				searchText: debouncedSearch,
				msgBoardID: videoHotlineData?.message?.messageBoardId,
			};
			setShowModal(true);
			dispatch(dabFilmsAction.dabFilmsGetByfilter(body));
		}
	}, [debouncedSearch]);

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleLoadDeleteModal = () => {
		dispatch(dabFilmsAction.dabFilmsDelete(selectedId));
		setShowModal(true);
		setShowDeleteModal(false);
	};

	if (dabFilmsData && !dabFilmsData.isLoading && dabFilmsData.isListSuccess) {
		dabFilmsData.isListSuccess = false;
		if (showModal) {
			setShowModal(false);
		}
	}

	if (
		selectedId >= 0 &&
		dabFilmsData.isSuccess &&
		dabFilmsData.isDeleteCompleted &&
		!dabFilmsData.isError
	) {
		showAlert(dabFilmsData.status, false);
		dabFilmsData.isSuccess = false;
		dabFilmsData.isDeleteCompleted = false;
		const body = {
			pageNumber: dabFilmsData?.items?.allDabFilms?.length === 1 ? currentPage - 1 : currentPage,
			pageSize: 25,
			searchText: debouncedSearch,
			msgBoardID: videoHotlineData?.message?.messageBoardId,
		};
		dispatch(dabFilmsAction.dabFilmsGetByfilter(body));
		setCurrentPage(dabFilmsData?.items?.allDabFilms?.length === 1 ? currentPage - 1 : currentPage);
		setSelectedId(-1);
	}
	if (!dabFilmsData.isSuccess && dabFilmsData.isError) {
		if (dabFilmsData.status === "Unauthorized") {
			history.push("/401");
		} else {
			showAlert(dabFilmsData.status, true);
		}
		dabFilmsData.isError = false;
		setSelectedId(-1);
		if (showModal) {
			setShowModal(false);
		}
	}

	React.useEffect(() => {
		if (!videoHotlineData?.message?.messageBoardId) {
			dispatch(videoHotlineAction.getMessageBoardID("dab-films"));
		}
		if (!!videoHotlineData?.message?.messageBoardId) {
			const body = {
				pageNumber: currentPage,
				pageSize: 25,
				searchText: debouncedSearch,
				msgBoardID: videoHotlineData?.message?.messageBoardId,
			};
			dispatch(dabFilmsAction.dabFilmsGetByfilter(body));
		}
		setShowModal(true);
	}, [videoHotlineData?.message?.messageBoardId]);

	React.useEffect(() => {
		if (dabFilmsData?.isUpdateStatus) {
			const body = {
				pageNumber: currentPage,
				pageSize: 25,
				searchText: debouncedSearch,
				msgBoardID: videoHotlineData?.message?.messageBoardId,
			};
			dispatch(dabFilmsAction.dabFilmsGetByfilter(body));
			const alertMessage = dabFilmsData?.status;
			if (alertMessage && alertMessage != "") {
				store.addNotification({
					title: "Success!",
					message: alertMessage,
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				dabFilmsData.isUpdateStatus = false;
				window.localStorage.setItem("alertMessage", "");
			}
		}
	}, [dabFilmsData?.isUpdateStatus]);

	const handleCreateNew = () => {
		window.location.href = "/dabfilms?page=add";
	};

	const handleSelectForDelete = (id: any) => {
		setSelectedId(id);
		setShowDeleteModal(true);
	};

	const handleCloseClick = () => {
		setShowDeleteModal(false);
	};

	const handleActiveDab = async (id: any, status: any) => {
		const data = {
			adminUserId: parseInt(getLoggedUserId()),
			messageId: id,
			isActive: !status,
		};
		setShowModal(true);
		await dispatch(dabFilmsAction.updatedabFilmsVideoStatus(data));
	};

	const getColorByStatus = (status: any) => {
		switch (status) {
			case 0:
				return "#FFC300";
			case 1:
				return "#008001";
			case 2:
				return "#FF0000";
			default:
				return "#000000";
		}
	};

	const getConversionStatus = (key: any) => {
		switch (key) {
			case 0:
				return "InProgress";
			case 1:
				return "Completed";
			case 2:
				return "Failed";
			default:
				return "-";
		}
	};

	return (
		<div data-testid="dabFilmsPage" className="dabfilms-list">
			<div className="card-box">
				<div className="card-box-link-back-div">
					<FontAwesomeIcon icon={faChevronLeft} />
					<CardLink
						onClick={() => history.push("/")}
						className="card-box-link-back"
						data-testid="bible-backtolist"
					>
						Back to List
					</CardLink>
				</div>
			</div>
			<div className="card-box">
				<Row className="filter-link-container justify-content-between">
					<Col lg="3">
						<Input
							type="search"
							onChange={(event) => setSearch(event.target.value)}
							className="form-control"
							id="search-filter"
							placeholder="Search here..."
							value={searchText}
						/>
					</Col>
					<Button
						id="submit"
						data-testid="createNewDabFilms"
						className="btn-submit-frm"
						onClick={handleCreateNew}
					>
						Create New
					</Button>
				</Row>
			</div>

			<div className="dabFilms-table">
				<table className="table table-hover" data-testid="dabFilmsTable">
					<thead data-testid="dabFilmsTableHead">
						<tr>
							<th scope="col" data-testid="detail-th">
								Details
							</th>
							<th scope="col" data-testid="authorname-th">
								Name
							</th>
							<th scope="col" data-testid="date-th">
								Created Date
							</th>
							<th scope="col" data-testid="conversion-status-th">
								Conversion & Thumbnail Status
							</th>
							<th scope="col" data-testid="status-th">
								Status
							</th>
							<th scope="col" data-testid="delete-th">
								Delete
							</th>
						</tr>
					</thead>
					<tbody data-testid="dabFilmsTableBody">
						{showModal ? <tr key='loading-row'>
								<td key='spinner' colSpan={6} className="text-center"><Spinner key='spinner-loader' /></td>
							</tr>
							:
						<>
						{dabFilmsData && dabFilmsData?.items?.allDabFilms?.length > 0 ? (
							dabFilmsData?.items?.allDabFilms?.map((data: any) => (
								<>
									<tr key={data?.dabFilm?.messageId}>
										<th scope="row" className="icon-column">
											<a
												href={`/dabfilms?id=${data?.dabFilm?.messageAttachments?.[0]?.messageAttachmentId}`}
												className="detail-link"
												data-testid="dabFilmsDetailButton"
											>
												<FontAwesomeIcon
													size="2x"
													icon={faEdit}
													title="Details"
													cursor="pointer"
													className="detailButton"
												/>
											</a>
										</th>
										<td id="authorName">{data?.dabFilm?.subject} </td>
										<td id="publish">
											{new Date(
												data?.dabFilm?.createdAtUtc
											).toLocaleDateString()}
										</td>
										<td id="conversion-status">
													<span
														style={{
															color: getColorByStatus(data?.dabFilm?.messageAttachments?.[0]?.hlsStatus),
														}}
													>
														{getConversionStatus(data?.dabFilm?.messageAttachments?.[0]?.hlsStatus)}
													</span>
												</td>
										<td id="actionswitch" className="text-center">
											<FormGroup switch>
												<Input
													type="switch"
													className="active-switch"
													data-testid="dabFilmsUpdateStatus"
													id="activeInactiveSwitch"
													checked={data?.dabFilm?.isActive}
													onChange={() =>
														handleActiveDab(
															data?.dabFilm?.messageId,
															data?.dabFilm?.isActive
														)
													}
												/>
											</FormGroup>
										</td>
										<td className="icon-column">
											<FontAwesomeIcon
												size="2x"
												icon={faTrashAlt}
												data-testid="dabFilmsDeleteButton"
												data-bs-toggle="tooltip"
												cursor="pointer"
												data-bs-placement="bottom"
												title="Delete"
												onClick={() =>
													handleSelectForDelete(
														data?.dabFilm?.messageAttachments?.[0]
															?.messageAttachmentId
													)
												}
											/>
										</td>
									</tr>
								</>
							))
						) : (
							<tr>
								<td colSpan={5} className="text-center h6">
									No Data found.
								</td>
							</tr>
						)}
						</>
						}
					</tbody>
				</table>
			</div>
			<div className="pagination">
				<ReactPaginate
					previousLabel={"<<"}
					nextLabel={">>"}
					breakLabel={"..."}
					pageCount={Math.ceil(+dabFilmsData?.items?.totalCount / 25)}
					marginPagesDisplayed={2}
					pageRangeDisplayed={3}
					onPageChange={(data) => {
						setCurrentPage(data.selected + 1);
						const body = {
							pageNumber: data.selected + 1,
							pageSize: 25,
							searchText: debouncedSearch,
							msgBoardID: videoHotlineData?.message?.messageBoardId,
						};
						setShowModal(true);
						dispatch(dabFilmsAction.dabFilmsGetByfilter(body));
					}}
					containerClassName={"pagination"}
					pageClassName={"page-item"}
					previousClassName={"page-item"}
					breakClassName={"page-item"}
					breakLinkClassName={"page-link"}
					nextClassName={"page-item"}
					pageLinkClassName={"page-link"}
					previousLinkClassName={"page-link"}
					nextLinkClassName={"page-link"}
					activeClassName={"active"}
					forcePage={currentPage - 1}
				/>
			</div>
			<Modal
				isOpen={showDeleteModal}
				backdrop="static"
				centered
				data-testid="deleteModal"
			>
				<ModalHeader>Delete {title ?? "Video"}</ModalHeader>
				<ModalBody className="modal-body">
					<form name="deleteForm">
						<div className="col-form-label" data-testid="dabFilmsDeleteMessage">
							Deleting this {title ?? "DAB Films"} will permanently remove. To confirm,
							please click Confirm Delete.
						</div>
					</form>
				</ModalBody>
				<ModalFooter>
					<Button
						type="button"
						color="secondary"
						data-bs-dismiss="modal"
						onClick={handleCloseClick}
						data-testid="cancelDeleteButton"
					>
						Cancel
					</Button>
					<Button
						type="button"
						color="primary"
						onClick={handleLoadDeleteModal}
						data-testid="confirmDeleteButton"
					>
						Confirm Delete
					</Button>
				</ModalFooter>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { dabFilmsData, videoHotlineData } = state;
	return {
		dabFilmsData,
		videoHotlineData,
	};
};

export default connect(mapStateToProps)(DABFilmsList);
